import axios from "axios";

const httpClient = axios.create();

httpClient.defaults.baseURL = "https://api.torusdigital.com";

httpClient.defaults.timeout = 50000;

export default httpClient;
